import IssuesBanner from "components/IssuesBanner";
import AccountPendingRemovalBanner from "./AccountPendingRemovalBanner";


export default function TopBanners() {
  return (
    <div className="flex flex-col dark">
      <AccountPendingRemovalBanner />
      <IssuesBanner />
    </div>
  );
};
